import * as React from 'react';
import classnames from "classnames";
import style from './Error.scss';
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: string
}>;

const Error: React.FunctionComponent<Props> = (props) => {
  return (
    <div className={classnames(style.container, props.className)}>
      {props.children}
    </div>
  );
};

export default Error;
